module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_6_A_5.d135f965.mp3";